<template>

    <div class="container-center" v-loading.fullscreen.lock="fullscreenLoading">

        <el-card class="box-card">

            <div slot="header" class="clearfix contract-data-top with-icon">
                <div>
                    <img src="data:image/png;base64,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">
                    <p><span class="title">{{ detail.name }}</span></p>
                    <!-- <p class="status">
                        <span :title="detailData.approveStatus" v-bind:class="['state-shet'+ detailData.approveStatus]">
                            {{ baseStatus[detailData.approveStatus] }}
                        </span>1
                    </p> -->
                    <div>类型：{{getTechType(detail.type)}}</div>
                </div>
                <div>
                    <el-button type="primary" size="medium" @click="showDialog" v-if="isShowReplyBtn">回复</el-button>
                </div>
            </div>

            <div class="reply-list">
                <div v-for="(item,index) in detail.dhsConWorkOrderDtlList" :key="index" class="reply-item">
                    <div class="item-header">
                        <span>{{item.type == 1? '收到' : '回复'}}联系单</span>
                        <span class="ml-20">{{item.updateDate}}</span>
                      
                    </div>
                    <div class="item-body">
                        <div>{{item.content}}</div>
                        <div class="file-list">
                            <span>附件：</span>
                            <div>
                                <div v-for="(file,index) in item.baseFileList" :key="index">
                                    <a :href="downloadApi +'?fileId=' + file.id" target="_blank">{{file.fileOldName || file.fileName}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

              <div class="text-center" style="padding:30px 0;">
                <el-button @click="$router.go(-1)" type="" size="medium" icon="el-icon-back">返回合同台账</el-button>
            </div>

            <div>
                <el-dialog title="回复" :visible.sync="replyVisible" width="800px" @close="resetForm" center>
                    <el-form label-width="160px" ref="form" :model="form" :rules="rules" size="mini">
                        <el-form-item label="回复内容：" prop="remark">
                            <el-input type="textarea"  :rows="4" placeholder="请输入回复内容" v-model="form.remark"></el-input>
                        </el-form-item>
                         <el-form-item label="附件：" prop="files">
                            <el-upload
                                class="upload-demo"
                                multiple
                                ref="upload"
                                :limit="20"
                                :action="uploadApi"
                                :file-list="form.files"
                                :on-success="handleAdd" :on-error="uploadError"
                                :before-upload="beforeUpload"
                                :on-remove="handleRemove" >
                                <el-button size="small" type="primary">上 传</el-button>
                                <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                                    <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="cancel">取 消</el-button>
                        <el-button type="primary" @click="submit" v-loading="btnLoading">保 存</el-button>
                    </div>
                </el-dialog>
            </div>

        </el-card>
    </div>

</template>

<script>
    import banner from '@/assets/imgs/banner_inviteMng.png'
    import util from '@/util'

    export default {
        name: 'contact-detail',
        data() {
            return {
                id:'',
                supplierId: this.$root.stockId,
                uploadApi: `${util.baseUrl}rest/file/upload`,
                downloadApi: `${util.baseUrl}rest/file/down`,
                replyList:[] ,
                fullscreenLoading: false,
                replyVisible:false,
                detail:{}, // 详情
                form: {
                    files: [],
                    remark: '',
                },
                rules: {
                    remark:[
                        {required:true,message:'请输入回复内容',trigger:'blur'}
                    ]
                },
                btnLoading:false,
                isShowReplyBtn:true,
                files:[],
              

            }
        },
        methods: {

            // 上传文件格式验证
            beforeUpload(file) {
                if (file.size / 1024 / 1024 > 100) {
                    this.$alert('上传附件大小请不要超过100M', '文件过大！', {type: 'error'})
                    return false
                }

                if (!util.allowUpload(file.name)) {
                    this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`, '文件类型不支持，已取消上传！', {type: 'error'})
                    return false
                }
                return true
            },

            uploadError() {
                this.$message({message: '上传出错，请稍后再试。', type: 'error'});
            },

            getDetail(){
                let params = {msgId: this.id,supplierId: this.supplierId}
                this.$http.post('rest/api/contract/getWorkOrderInfo',params).then(res =>{
                    if(res.data.result) {
                        this.detail = res.data.value || {};
                        this.isShowReplyBtn = this.detail.status == '1' ? true: false;
                    }else{
                        this.$message.error(res.data.message || '操作失败')
                    }
                })
            },

            // 已读
            setReadStatus(){
                let params = {msgId: this.id,supplierId: this.supplierId}
                this.$http.post('rest/api/contract/readWorkOrder',params).then(data =>{})
            },

            showDialog(){
                this.replyVisible = !this.replyVisible;
            },  

            resetForm(){
                this.form.files = [];
                this.form.remark = '';
            },

            handleRemove (file, fileList) {
                // this.form.files = this.form.files.filter(function (f) {
                //     return f.uid !== file.uid
                // });
                // this.form.files = fileList;
                // console.log(this.$refs.upload.uploadFiles,'remove')
            },
            handleAdd (response, file, fileList) {
                // console.log(response, file,JSON.parse(JSON.stringify(fileList)) ,'rest')
                // console.log(this.files,6666)
                // console.log(this.$refs.upload.uploadFiles,44444)

            },

            cancel(){
				this.replyVisible = !this.replyVisible;
				this.btnLoading = false;
            },

            submit(){
                this.$refs.form.validate().then(()=>{
                    this.btnLoading = !this.btnLoading;
                    let params = {
                        orderId: this.id,
                        content: this.form.remark,
                        baseFileList: __getBaseFiles__(null,this.$refs.upload.uploadFiles)
                    }
                    this.submitMethod(params);
                })
            },

            submitMethod(params){
                 this.$http.post('rest/api/contract/applyWorkOrder',params).then(res =>{
                    if(res.data.result) {
                        this.$message.success(res.data.message || '操作成功');
                        this.cancel();
                        this.getDetail();
                    }else{
                        this.btnLoading = false;
                        this.$message.error(res.data.message || '操作失败');
                    }
                })
            },

            // 联系单类型
            getTechType(val){
                if(!val) return;
                return {
                    '1': '核价联系单',
                    '2': '结算联系单',
                }[val]
            },
        },
        created () {
            this.id = this.$route.params.id;
            this.billId = this.$route.params.billId;
            this.getDetail();
            this.setReadStatus();
            this.$root.headImage.src = banner
            this.$root.activeIndex = 'home'
            this.$root.isPublic = false
            this.$root.navs = []
        },
        mounted () {
            this.$root.navs = [{
                name: '合同业务列表',
                path: '/contractList'
            }, {
                name: decodeURIComponent(this.$route.params.name),
                path: '/contractSheet/' + encodeURIComponent(this.billId)
            }, {name: '详情'}]
            util.toTop()
        }
    }

    function __getBaseFiles__(file, fileList) {
        let fs = [];
        fileList.forEach(function (item) {
            if (item.response) {
                let f = item.response.basefiles[0];
                item.bizTableName = f.biztablename;
                item.bizTablePkName = f.biztablepkname;
                item.bizTablePkValue = f.biztablepkvalue;
                item.fid = f.fid;
                item.fileCatagoryId = f.filecatagoryid;
                item.fileDesc = f.filedesc;
                item.fileOldName = f.fileoldname;
                item.name = f.fileoldname;
                item.fileName = f.filename;
                item.filePath = f.filepath;
                item.fileSize = f.filesize;
                item.fileType = f.filetype;
                item.sort = f.sort;
            }
            fs.push(item);
        });
        console.log(fs);
        return fs
    }

</script>

<style scoped lang="postcss">
    @import '../../../assets/common.css';

    .ml-20{
        margin-left:20px;
    }


    .contract-data-top{
        display:flex;
        justify-content: space-between;
        align-items: center;
    }
    a {
        color: var(--cMain);
        cursor: pointer;
    }

    ul {
        padding: 0;
        margin: 0;
    }

    ul li {
        list-style: none;
    }

    .box-card {
        margin: 30px 0;
    }


    .fade-title {
        display: inline-block;
        margin-bottom: 20px;
        color: var(--cTxt2);
        font-size: 15px;
        font-weight: bold;
        line-height: 28px;
    }

    .fade-line {
        border-top: 1px dashed #ddd;
        margin: 40px 0;
    }


    .detail-box {
        padding: 20px 120px;
    }

    .detail-box .el-row {
        line-height: 48px;
    }

    .detail-box .text-right {
        color: var(--cTxt3);
    }

    
    .reply-item{
        border:solid 1px  #ebeef5;
        margin-bottom: 10px;
       
    }
    .reply-list .item-header{
        padding:10px 20px;
        font-size:14px;
        color:#5f5f5f;
        border-bottom:solid 1px #ebeef5;
    }

    .reply-list .item-body{
        padding:10px 20px;
    }

    .reply-list .file-list{
        display: flex;
        margin-top:20px;
        font-size:14px;
    }
    .file-list span{
        flex-shrink: 0;
        color:#5f5f5f;
       
    }

</style>



// WEBPACK FOOTER //
// src/pages/dsp/contract/vDetail14.vue